export default {"src":"/_next/static/media/DEVELOPER_DISABLED.5509c130.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};